// extracted by mini-css-extract-plugin
export default {"select":"TemplateSelector_select__iqpko","menuItem":"TemplateSelector_menuItem__D+wus"};